export default __webpack_public_path__ + "static/media/mot_1.a25fac14.svg";